import urlBuilder from "@sanity/image-url"
import { mySanityClient } from "./sanityClient"

export const camelCaseToNormal = tag => {
  const result = tag.replace(/([A-Z])/g, " $1")
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1)
  return finalResult
}

export const createImageUrlArray = albumImages => {
  // const imageUrlArray = albumImages.map(imageData => imageData.asset.id)

  // Common error: make sure @sanity/client is installed
  const builder = urlBuilder(mySanityClient)
  // Get the url for a given source
  const urlFor = source => builder.image(source)

  const imageUrlArray = albumImages.map(imageData => {
    const url = urlFor(imageData.asset.id)
      .width(2000)
      .format("jpg")
      .fit("max")
      .url()

    const previewUrl = urlFor(imageData.asset.id)
      .width(200)
      .height(200)
      .format("jpg")
      .url()

    const altText = imageData?.altText || ""
    let captionText = imageData?.caption || imageData?.imageTitle || ""
    // Add credit to caption
    if (imageData?.imageCredit) {
      captionText = captionText.concat(", Credit: ", imageData.imageCredit)
    }
    return {
      original: url,
      originalAlt:
        altText || imageData.caption || imageData.asset.originalFilename || "",
      thumbnail: previewUrl,
      thumbnailAlt:
        altText || imageData.caption || imageData.asset.originalFilename || "",
      description: captionText,
    }
  })

  return imageUrlArray
}
